import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import useQuery from "../utils/useQuery";
import { axiosPrivate, axiosQuick } from "../api/axios";
import "../assets/scss/components/dashboard.scss";
import Header from "../components/shared/header";
import moment from "moment";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import AddUser from "../components/adduser";
import { categoryList } from "../data/categories";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import loader from "../utils/Helper";
import { Tooltip, CircularProgress} from "@mui/material";
import _ from "lodash";
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Slide from "@mui/material/Slide";

const DELETE_USER = "/deleteUser";
const REACTIVATE_USER = "/reactivateUser";
const GET_USERS = "/getAllUsers";
const GET_USER = "/account";

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

const UserList = () => {
  const toast = useRef(null);
  const { setQueryData } = useQuery();
  const [query, setQuery] = useState(null);

  const [displayResponsive, setDisplayResponsive] = useState(false);
  const userData = JSON.parse(localStorage.getItem("user"));
  const [tableData, setTableData] = useState(false);
  const [departmentFilter, setDepartmentFilter] = useState(null);
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState(false);
  const [message, setMessage] = useState(false);
  const statusList = [
    { status: "All", code: null },
    { status: "Active", code: true },
    { status: "In-Active", code: false },
  ];
  const [statusFilter, setStatusFilter] = useState(statusList[0]);
  const [account, setAccount] = useState(null);
  const [exportRunning, setexportRunning] = useState(false);

  const getData = async () => {
    loader.isLoading(true);
    const response = await axiosQuick.get(`${GET_USERS}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userData.jwtToken}`,
      },
    });
    setQuery(response.data);
    setTableData(response.data);
    let id;
    if (query) {
      query.map((singleItem, index) => {
        id = singleItem.id;
      });
      setQueryData({
        id: id,
      });
    } else {
    }
    loader.isLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const getUser = async (accountId) => {
    try {
      loader.isLoading(true);
      const response = await axiosQuick.get(`${GET_USER}/${accountId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userData.jwtToken}`,
        },
      });
      if(response?.status==200){
        setAccount(response.data);
       
        setDisplayResponsive(true);
      }
     
    } catch (error) {
      // Handle the error here
      console.error("Error fetching user data:", error);
    }finally{
      loader.isLoading(false);
    }
  };
  const handleEdit = (accountId) => {
    getUser(accountId);
  };

  const handleDelete = (event) => {
    loader.isLoading(true);
    const itemId = event.currentTarget.id;
    
    const deleteItem = async () => {
      try {
        const response = await axiosPrivate.delete(
          `${DELETE_USER}/${itemId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userData.jwtToken}`,
            },
          }
        );
        if (response.status === 200) {
          setOpen(true);
          setSeverity('success');
          setMessage(response?.data?.error);
          getData();
        }
      } catch (err) {
        // Handle error here, e.g., show an Error
        console.error("Error deleting user:", err);
        setOpen(true);
        setSeverity('error');
        setMessage(err?.data?.error||"An error occurred while deleting the user");
      } finally {
        loader.isLoading(false);
      }
    };
  
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, deactivate consultant!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteItem();
      } else {
        loader.isLoading(false);
      }
    });
  };

   const handleReactivation = (event) => {
    loader.isLoading(true);
    const itemId = event.currentTarget.id;
    
    const deleteItem = async () => {
      try {
        const response = await axiosPrivate.get(
          `${REACTIVATE_USER}/${itemId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userData.jwtToken}`,
            },
          }
        );
        if (response.status === 200) {
          setOpen(true);
          setSeverity('success');
          setMessage(response?.data?.error);
          getData();
        }
      } catch (err) {
        // Handle error here, e.g., show an Error
        console.error("Error re-activating user:", err);
        setOpen(true);
        setSeverity('error');
        setMessage(err?.data?.error||"An error occurred while re-activating the user");
      } finally {
        loader.isLoading(false);
      }
    };
  
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, activate consultant!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteItem();
      } else {
        loader.isLoading(false);
      }
    });
  };

  const actionsBodyTemplate = (rowData) => {
    return (
      <div style={{display:'inline-flex'}} >
        <i
          title="Edit "
          className="fa-solid fa-pencil px-2"
          onClick={(e) => handleEdit(rowData.id)}
          style={{ cursor: "pointer" }}
        ></i>
       {rowData.isActive &&
        <i
          title="Deactivate"
          id={rowData.id}
          onClick={(e) => handleDelete(e)}
        
          className="pi pi-ban  px-2 text-danger"
          style={{ cursor: "pointer" }}
        ></i>
       }
       {!rowData.isActive &&
        <i
          title="Activate"
          id={rowData.id}
          onClick={(e) => handleReactivation(e)}
        
          className="pi pi-replay px-2 text-success"
          style={{ cursor: "pointer" }}
        ></i>
       }
      </div>
    );
  };

  const createdOnBodyTemplate = (rowData) => {
    return   moment.utc(rowData.createdOn).local().format("MMMM DD, YYYY");
    //  moment(new Date(rowData.createdOn)).format("MMMM DD, YYYY");
  };

  const categoryBodyTemplate = (rowData) => {
    const selectedCategories = [];
const ids =rowData.categoryId
    for (const id of ids ) {
        const category = categoryList.find(item => item.id === id);
        if (category) {
            selectedCategories.push(category.category);
        }
    }
    const selectdepartment= selectedCategories.join(',  ');

 return   <>
    {selectdepartment ?  <Tooltip title={selectdepartment} placement="bottom" >
          <span className="remarksSpan">
            {selectdepartment?.substring(0, 25)}{selectdepartment?.length > 25 && '...'}
          </span>
        </Tooltip>:null}</>

   
  };

  const handleSearch = (e) => {
  
    if (e.target.value != "") {
      var res = query.filter(
        (a) =>
          (a.referenceName.toLowerCase().includes(e.target.value.toLowerCase()) ||
           
            a.email.toLowerCase().includes(e.target.value.toLowerCase())) &&
          (!departmentFilter || a.categoryId.includes(departmentFilter.id) )
      );
      setTableData(res);
    } else {
      var res = query.filter(
        (a) => !departmentFilter || a.categoryId.includes(departmentFilter.id)
      );
      setTableData(res);
    }
  };

  const rowClass = (data) => {
    if (new Date(data.dueDate) < new Date()) {
      return {
        dueDateGone: true,
      };
    }

    if (
      new Date(data.dueDate) > new Date() &&
      parseInt(
        (new Date(data.dueDate) - new Date()) / (1000 * 60 * 60 * 24),
        10
      ) < 3
    ) {
      return {
        dueDateNear: true,
      };
    }
  };

  const handleDepartmentChange = (e) => {
  
    setDepartmentFilter(e.value);
    if (e.value) {
      var res = query.filter((a) => a.categoryId.includes(e.value.id) );
      setTableData(res);
    } else {
      setTableData(query);
    }
  };

  const handleStatusChange = (e) => {

    setStatusFilter(e.value);
    if (e.value && e.value.code != null) {
      var res = query.filter((a) => a.isActive == e.value.code );
      setTableData(res);
    } else {
      setTableData(query);
    }
  };


  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      setexportRunning(true);
      loader.isLoading(true)
      const CustomHeadersKeys = {
        userName: "Username",
        referenceName: "Name",
        email: "Email",
        phone: "Phone Number",
      };
      const keysToRemove = [
        "id",
        "roleId",
        "categoryId",
        "whatsAppPhone",
        "streetAddress",
        "city",
        "state",
        "country",
        "companyName",
        "pan",
        "zipCode",
        "isActive",
        "queryCount",
        "createdOn",
        "isProfileComplete"
      ];
      const export_item =
        tableData;
      // Iterate over the export_item array and transform the data with custom headers
      const selectedTabledata = export_item.map((obj) => {
        return _.mapKeys(
          _.omit(obj, keysToRemove),
          (value, key) => CustomHeadersKeys[key] || key
        );
      });


      const worksheet = xlsx.utils.json_to_sheet(selectedTabledata);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

         saveAsExcelFile(excelBuffer, "Consultants");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });
  
        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
      setexportRunning(false);
      loader.isLoading(false);
    }).catch((err) => {
      setexportRunning(false);
    });
  };

    const handleClose = async () => {
    setOpen(false);
  };


  return (
    <div style={{ backgroundColor: "white" }}>
            <Snackbar
          open={open}
          autoHideDuration={5000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          TransitionComponent={SlideTransition}
          >
          <Alert
              onClose={handleClose}
              severity= {severity}
              variant="filled"
              sx={{ width: "100%" }}
          >
              {message}
          </Alert>
      </Snackbar>
      <Header />

      <Dialog
        header={account ? "Update Consultant Details" : " Add Consultant"}
        visible={displayResponsive}
        onHide={() => {
          setDisplayResponsive(false);
          setAccount(null);
          
        }}
        
        style={{width:'75%',height:'80%'}}
      >
        <AddUser
          reloadData={getData}
          hidePopup={setDisplayResponsive}
          existinguser={account}
        />
      </Dialog>

      <div className="dashboard-area">
        {userData.isSuperAdmin && (
          <div className="row" style={{ marginTop: "10px" }}>
            <div className="col-sm-12">
              <div>
                <div className="row">
                  <div className="col-sm-3">
                    <Dropdown
                      showClear
                      onChange={(e) => {
                        handleDepartmentChange(e);
                      }}
                      optionLabel="category"
                      value={departmentFilter}
                      filter
                      filterBy="category"
                      options={categoryList}
                      placeholder="Select a Department"
                      style={{ marginRight: "10px", width: "100%" }}
                    />
                  </div>
                  <div className="col-sm-2">
                    <Dropdown
                      onChange={(e) => {
                        handleStatusChange(e);
                      }}
                      optionLabel="status"
                      value={statusFilter}
                      options={statusList}
                      placeholder="Select a Status"
                      style={{ marginRight: "10px", width: "100%" }}
                    />
                  </div>
                  <div className="col-sm-2">
                    <span className="p-input-icon-left">
                      <i className="pi pi-search" />
                      <InputText placeholder="Search" onChange={handleSearch} />
                    </span>
                  </div>

                  <div className="col-sm-5">
                    <div
                      className="btn-create-small submitbutton"
                      style={{ cursor: "pointer",marginTop:'0px' }}
                      onClick={!exportRunning ? exportExcel : null}
                      data-pr-tooltip="XLS"
                    >
                      {exportRunning ? (
                        <>
                          <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                          <CircularProgress size={15} />
                        </>
                      ) : (
                        <>
                          <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                          Export All
                        </>
                      )}
                    </div>
                    <div
                      className="btn-create-small submitbutton"
                      style={{ cursor: "pointer",marginTop:'0px' }}
                      onClick={() => setDisplayResponsive(true)}
                    >
                      <i
                        title=" Add Consultant"
                        className="fa-solid fa-plus px-2"
                      ></i>
                      Add Consultant
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-sm-12">
            {query && (
              <div className="add-scroll">
                <DataTable
                  value={tableData}
                  paginator
                  rows={10}
                  responsiveLayout="scroll"
                  rowClassName={rowClass}
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  rowsPerPageOptions={[10, 20, 50]}
                  sortField="username" sortOrder={1}
                >
                  {/* <Column field="id" header="#" sortable></Column> */}
                  {/* <Column field="firstName" header="First Name" sortable></Column>
                    <Column field="lastName" header="Last Name" sortable></Column> */}

                  <Column field="username" header="Username" sortable></Column>
                  <Column
                    field="referenceName"
                    header="Name"
                    sortable
                  ></Column>
                  <Column field="email" header="Email" sortable></Column>
                  <Column field="phone" header="Phone Number" sortable></Column>
                  <Column
                    field="categoryId"
                    header="Department"
                    body={categoryBodyTemplate}
                    sortable
                  ></Column>
                  <Column
                    field="queryCount"
                    header="Queries Count"
                    sortable
                  ></Column>
                  <Column
                    field="createdOn"
                    header="Created On"
                    body={createdOnBodyTemplate}
                    sortable
                  ></Column>
                  <Column header="Actions" body={actionsBodyTemplate}></Column>
                </DataTable>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default UserList;
